import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

//axios.defaults.baseURL = 'http://localhost:8000/';
axios.defaults.baseURL = 'https://dev.danb.uk/';

Vue.config.productionTip = false

Vue.directive('numericOnly',
	function (el, binding, vnode) {
		el.addEventListener('keyup', () => {
			let regex = /^[0-9.]*$/
			if (!regex.test(el.value)) {
				el.value = el.value.slice(0, -1)
			}
		})
	}
)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
